import { render, staticRenderFns } from "./yi_cross_select.vue?vue&type=template&id=168da67e&"
import script from "./yi_cross_select.vue?vue&type=script&lang=js&"
export * from "./yi_cross_select.vue?vue&type=script&lang=js&"
import style0 from "./yi_cross_select.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports